import React from 'react';
import { Text } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { Classifier } from 'types/generated/graphql';
import { useSearchableClassifier } from './useSearchableClassifier';

const searchableAttributeClass = css({
    cursor: 'pointer',
    _hover: {
        textDecoration: 'underline',
    },
});

export const SearchableClassifier = ({
    classifier,
    isSearchEnabled = true,
    isPopover = false,
}: {
    classifier: Classifier;
    isSearchEnabled?: boolean;
    isPopover?: boolean;
}) => {
    const {
        handleClick,
        code,
        filterType,
        displayName,
        visibility,
        classifierRef,
    } = useSearchableClassifier({
        classifier,
    });

    if (isSearchEnabled && code && filterType) {
        return (
            <Text
                ref={isPopover ? undefined : classifierRef}
                key={code}
                onClick={(event) => handleClick(event)}
                textStyle="body-sm"
                color="text.medium"
                marginRight="xs"
                className={searchableAttributeClass}
                textTransform="lowercase"
                style={{
                    visibility: isPopover ? 'visible' : visibility,
                }}
            >
                {displayName}
            </Text>
        );
    }

    // fallback
    return (
        <Text
            ref={classifierRef}
            key={code}
            textStyle="body-sm"
            color="text.medium"
            marginRight="2xs"
            textTransform="lowercase"
        >
            {displayName}
        </Text>
    );
};
